'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';

const getTransactionLink = (_a) => __awaiter(void 0, [_a], void 0, function* ({ walletConnector, transactionHash, }) {
    try {
        if (!walletConnector) {
            return undefined;
        }
        const [blockExplorerUrl] = yield walletConnector.getBlockExplorerUrlsForCurrentNetwork();
        if (!blockExplorerUrl)
            return undefined;
        const url = new URL(blockExplorerUrl);
        url.pathname = `/tx/${transactionHash}`;
        return url.toString();
    }
    catch (error) {
        return undefined;
    }
});

export { getTransactionLink };
